import { render, staticRenderFns } from "./CircleChart.vue?vue&type=template&id=064ee333&scoped=true&"
import script from "./CircleChart.vue?vue&type=script&lang=ts&"
export * from "./CircleChart.vue?vue&type=script&lang=ts&"
import style0 from "./CircleChart.vue?vue&type=style&index=0&id=064ee333&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ee333",
  null
  
)

export default component.exports